import { render, staticRenderFns } from "./Question8.vue?vue&type=template&id=2e5b79a0&scoped=true"
import script from "./Question8.vue?vue&type=script&lang=js"
export * from "./Question8.vue?vue&type=script&lang=js"
import style0 from "./Question8.vue?vue&type=style&index=0&id=2e5b79a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b79a0",
  null
  
)

export default component.exports